// @flow
import React from 'react';
import classNames from 'classnames';
import {
    NEW_LISTING,
    NEW_LISTING_20_OFF,
    FREE_CANCELLATION,
    PP_ACCEPTED
} from '../../../constants/badges';

import type {BadgeShape} from '../../Hit/Hit';

type SuperlativeBadgesProps = {
    superlativesBadges: BadgeShape[]
};

type RankedBadgesProps = {
    rankedBadges: BadgeShape[]
};

type BadgeProps = {
    badges: BadgeShape[],
    className: string
};

const hasBadges = (badges: BadgeShape[]): boolean =>
    !!badges && !!badges.length;

export const Badge = ({badges, className}: BadgeProps) => {
    if (!hasBadges(badges)) {
        return null;
    }

    return (
        <span className={className} aria-hidden="true">
            {badges[0].name}
        </span>
    );
};

export const SuperlativeBadge = ({
    superlativesBadges
}: SuperlativeBadgesProps) => {
    const badges = superlativesBadges.filter(
        (badge) => ![NEW_LISTING, NEW_LISTING_20_OFF].includes(badge.id)
    );

    return <Badge className="HitInfo__superlative" badges={badges} />;
};

export const NewListingBadge = ({
    superlativesBadges
}: SuperlativeBadgesProps) => {
    const badges = superlativesBadges.filter((badge) =>
        [NEW_LISTING, NEW_LISTING_20_OFF].includes(badge.id)
    );
    const className = classNames(
        'HitInfo__superlative',
        'HitInfo__newListingSuperlative'
    );

    return <Badge className={className} badges={badges} />;
};

export const RankedBadges = ({rankedBadges}: RankedBadgesProps) => {
    let badges = rankedBadges.filter(
        (badge) => badge.id !== FREE_CANCELLATION && badge.id !== PP_ACCEPTED
    );

    return <Badge badges={badges} className="HitInfo__ranked" />;
};
